import { APIClient } from '@frontend/api-utils';
import { Certificate } from '@frontend/certificate/types';

export class CertificateEnumClient extends APIClient {
    public static readonly endpoint = '/certificate-api/v1';

    public static async certificateColumns(): Promise<keyof Certificate[]> {
        const response = await this.fetch(`${this.endpoint}/certificate-columns`);
        return await this.handleResponse<keyof Certificate[]>(response);
    }
}
